module.exports = __webpack_public_path__ + "img/guize.765d9961.png";